import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'lucide-react';
import PublicSidebar from './PublicSidebar';

export default function PublicLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      {/* Mobile backdrop */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/50 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <PublicSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex-1 flex flex-col h-full overflow-y-auto">
        {/* Mobile top bar */}
        <div className="flex md:hidden items-center gap-3 px-4 h-14 flex-shrink-0 bg-white border-b border-gray-100 sticky top-0 z-30">
          <button
            onClick={() => setSidebarOpen(true)}
            className="text-gray-500 hover:text-gray-900 transition-colors p-1"
            aria-label="Open menu"
          >
            <Menu size={22} />
          </button>
          <span className="font-black text-gray-900 text-lg tracking-tight">TraderBro</span>
          <Link
            to="/login"
            className="ml-auto px-4 py-1.5 bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg font-bold text-sm transition-colors"
          >
            Sign In
          </Link>
        </div>

        <main className="flex-1">
          {children}
        </main>
      </div>
    </div>
  );
}
